module.exports = __webpack_public_path__ + "img/record_to_solvet_the_problem.79a7ff98.svg";